import { Box } from '@amzn/awsui-components-react';

export const ValueWithLabel = ({ label, children }: {label: string, children: any}) => (
    <div>
        <Box margin={{ bottom: 'xxxs' }} color='text-label'>
            {label}
        </Box>
        <div>{children}</div>
    </div>
);
  
/**
   * Format payment option to be displayed in UI
   */
export function formatPaymentOption(payment: string): string {
    if (payment === 'ON_DEMAND') {
        return 'On Demand';
    }
    // payment option could only be 1 year or 3 years
    let year = 1;
    let type = 'All Upfront';
    if (payment.includes('THREE')) {
        year = 3;
    } else if (payment.includes('ONE')) {
        year = 1;
    }
    if (payment.includes('NO')) {
        type = 'No Upfront';
    } else if (payment.includes('PARTIAL')) {
        type = 'Partial Upfront';
    }
    return `Standard ${year}yr - ${type}`;
}
  
